import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import TreatmentModal from '../components/TreatmentModal/TreatmentModal'
import { withStyles } from '@material-ui/core/styles'
import { getPatientTreatments, createPatientTreatment } from '../api'
import { orderByDate } from '../utils'
import moment from 'moment-timezone'

const styles = theme => ({
  page: {
    height: 'calc(100% - 120px)',
    width: '100%',
    overflow: 'scroll',
    padding: 40
  },
  header: {
    fontSize: '1.5rem',
    margin: '20px 0'
  },
  narrowColumn: {
    width: 50
  },
  table: {
    width: 'auto',
    maxWidth: '80%',
    marginRight: 40
  },
  mediumColumn: {
    width: 100
  },
  wideColumn: {
    width: 150
  },
  flex: {
    display: 'flex'
  },
  activeTreatment: {
    display: 'flex',
    height: 300
  },
  textInput: {
    marginTop: 20,
    marginRight: 40
  },
  pastTreatment: {
    cursor: 'pointer',
    display: 'inline-block',
    margin: '2px 0',
    '&:hover': {
      backgroundColor: '#DDDDDD',
    },
  }
})

class Treatments extends Component {
  constructor (props) {
    super(props)

    this.state = {
      treatments: [],
      displayModal: false
    }
  }

  componentDidMount () {
    const { id } = this.props.patient
    this.patientId = id
    getPatientTreatments(id).then(treatments => {
      const sortedTreatments = orderByDate(treatments, 'start_date').reverse()
      this.setState({treatments: sortedTreatments, activeTreatment: sortedTreatments[0]})
    })
  }

  toggleModal = (e) => {
    this.setState({displayModal: !this.state.displayModal})
  }

  createNewTreatment = (treatmentData) => {
    return createPatientTreatment(this.patientId, treatmentData).then(response => {
      const newTreatments = orderByDate(this.state.treatments.slice().concat([response]), 'start_date').reverse()
      this.setState({
        treatments: newTreatments,
        activeTreatment: newTreatments[0],
        displayModal: false
      })
    })
  }

  renderStartDate () {
    const { activeTreatment } = this.state
    return this.renderSingleCellTable('Start Date', moment.utc(activeTreatment.start_date).format('MMMM DD, YYYY'))
  }

  renderCycles () {
    const { activeTreatment } = this.state
    return this.renderSingleCellTable('Number of Cycles', activeTreatment.cycles)
  }

  renderTreatmentNotes () {
    const { activeTreatment } = this.state
    return this.renderSingleCellTable('Notes', (activeTreatment.notes || 'No notes recorded.'))
  }

  renderSingleCellTable (header, value) {
      const { classes } = this.props
      return (
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.wideColumn}>{header}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell className={classes.wideColumn}>
                { value }
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )
  }

  renderDrugTable () {
    const { activeTreatment } = this.state
    const { classes } = this.props

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.wideColumn}>Drug</TableCell>
            <TableCell className={classes.narrowColumn}>Dose</TableCell>
            <TableCell className={classes.narrowColumn}>Unit</TableCell>
            <TableCell className={classes.mediumColumn}>Frequency</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { activeTreatment.drugs.map(drug => (
            <TableRow key={drug.id}>
              <TableCell>{drug.drug_name}</TableCell>
              <TableCell>{drug.dosage_value}</TableCell>
              <TableCell>{drug.dosage_units}</TableCell>
              <TableCell>{`${drug.frequency_value} ${drug.frequency_units}`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  renderActiveTreatment () {
    const { activeTreatment } = this.state
    const { classes } = this.props

    if (!activeTreatment) return <div/>
    return (
      <div className={classes.activeTreatment}>
        { this.renderStartDate() }
        { this.renderCycles() }
        { this.renderDrugTable() }
        { this.renderTreatmentNotes() }
      </div>
    )
  }

  renderTreatments () {
    const { classes } = this.props

    return (
      <div>
        <Typography className={classes.header}>Treatment</Typography>
        { this.renderActiveTreatment() }
        <Typography className={classes.header}>Historical Updates</Typography>
        { this.state.treatments.map(treatment => (
          <div
            onClick={e => this.setState({activeTreatment: treatment})}>
              <p className={classes.pastTreatment}>
                { moment.utc(treatment.start_date).format('MMMM DD, YYYY') }
              </p>
          </div>
        ))}
      </div>
    )
  }

  render () {
    const { classes } = this.props

    return (
      <div className={classes.page}>
        <Button variant="contained" color="primary" onClick={this.toggleModal}>
          Add New Treatment
        </Button>
        { this.state.treatments.length > 0 &&  this.renderTreatments() }
        <TreatmentModal patientId={this.patientId} open={this.state.displayModal} onClose={e => this.setState({displayModal: false})} onSave={this.createNewTreatment}/>
      </div>
    )
  }
}

export default withStyles(styles)(Treatments)



// WEBPACK FOOTER //
// ./src/pages/Treatments.js